<template>
    <div class="vh-100 d-flex justify-content-center align-items-center" style="background-color: #f3f3f3;">
      <div>
          <div class="bg-white ps-md-5 ps-4 pe-md-5 pe-4 pt-5 pb-4 text-center" style="margin: 0 auto; max-width: 520px !important; box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;">
            <form @submit.prevent="submitLogin">
              <img :src="logoLight" style="height: 45px;"/>
              <h5>Customer / Partner Login</h5>

              <br/>
              <div class="input-group mb-2" style="height: 50px;">
                <input type="text" class="form-control rounded-0" placeholder="Email Address" v-model="userNameOrEmail" required>
              </div>

              <div class="input-group mb-2" style="height: 50px;" >
                <input type="text" class="form-control rounded-0" placeholder="Order Number / Partner Code" v-model="userPassword" required>
              </div>

              <div class="alert alert-info" role="alert">
                Enter email and exclusive discount code for partner access or email and order number for order details.
              </div>

              <button type="submit" class="btn btn-primary w-100 fw-bold rounded-0" style="height: 50px; font-family: 'Montserrat'; color: #001823;">ACCESS</button>
              
              <div class="text-center my-3">
                <a type="button" class="text-decoration-none fs-6 text-secondary" @click="showRecoveryModal">Forgot your discount code or order number? Click here!</a>
              </div>
            </form>
            <br/>
            <div><img :src="tipmEcmsImages" class="w-100"/></div>
          </div>
        
          <a :href="constants.SITEURL+'/shop-modules'" style="margin: 0 auto; ">
            <button type="button" class="btn text-white w-100 fw-bold mt-4" style="height: 50px; color: #001823; background-color: #001823;">
              <img :src="mLogoGreen" class="me-2" style="height: 90%;"/> CONTINUE SHOPPING
            </button>
          </a>
      </div>
      <!-- <div><img :src="tipmEcmsImages" style="margin-top: -120px; width: 700px;"/></div> -->
      
      <!-- Recovery Modal -->
      <div class="modal fade" id="recoveryModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="recoveryModalLabel">Recover Discount Code or Order Number</h5>
                             <button type="button" class="btn-close" @click="hideRecoveryModal" aria-label="Close" :disabled="isRecoveryLoading"></button>
            </div>
            <div class="modal-body py-3">
              <form @submit.prevent="submitRecovery">
                Enter email associated with your discount code or order.
                <input id="recovery-email" type="text" class="form-control rounded-0" placeholder="Email" v-model="recoveryEmail" required :class="isRecoveryLoading ? 'disabled' : ''">

                <span class="mt-2 text-danger" v-if="recoveryResponseError">{{ recoveryResponseErrorMessage }}</span>
                
                <div class="d-flex flex-row mt-3">
                                     <button type="button" class="w-50 me-1 btn btn-secondary fw-bold" @click="hideRecoveryModal" style="font-family: 'Montserrat';" :class="isRecoveryLoading ? 'disabled' : ''">Cancel</button>
                  <button type="submit" class="w-50 ms-1 btn btn-primary mb-2 fw-bold" style="font-family: 'Montserrat'; color: #001823;" :class="isRecoveryLoading ? 'disabled' : ''">
                    <span v-if="!isRecoveryLoading">REQUEST</span>
                    <span v-else>
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      PROCESSING...
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
import Swal from 'sweetalert2'
import store from '../store'
import Mixin from '../mixins/global.mixin'
import { mapState } from 'vuex'
import axios from 'axios'
import { Modal } from 'bootstrap'
import logoDark from '../assets/maks-enterprises-logo-dark-resized.png'
import logoLight from '../assets/maks-enterprises-logo-light-resized.png'
import tipmEcmsImages from '../assets/TIPM-Reflections-Transparent-768x384.webp'
import mLogo from '../assets/Maks-M-logo.png'
import mLogoLight from '../assets/m-logo-dark.png'
import mLogoGreen from '../assets/tipm-rebuilders-favicon-01-002.png'
import appConstants from '@/constants/app.constants'; 

export default defineComponent({
  name: 'LoginComponent',
  mixins: [Mixin],
  computed: mapState([
    'jwtToken',
    'currentSessionEmail',
  ]),
  watch: {
    userNameOrEmail: function (newVal) {
      if (this.validateEmail(newVal)) {
        try {
          axios.get(appConstants.SITEURL+'/wp-json/custom-api/v1/check-admin-email/'+newVal)
          .then((response) => {
            if (response.data) {
              this.isAdmin = response.data.is_admin;
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  setup: () => {
    return {
      constants: appConstants
    }
  },
  data: () => {
    return {
      logoDark: logoDark,
      logoLight: logoLight,
      tipmEcmsImages: tipmEcmsImages,
      mLogo: mLogo,
      mLogoLight: mLogoLight,
      mLogoGreen: mLogoGreen,
      userPassword: null,
      queryParams: {},
      showQueryParams: false,
      settings: appConstants,
      formTitle: null,
      isAdmin: false,
      recoveryEmail: '',
      recoveryResponseError: false,
      recoveryResponseErrorMessage: null,
      isRecoveryLoading: false,
      recoveryModalInstance: null,
    }
  },
  methods: {
    submitLogin: async function () {
      this.toggleFullScreenSpinner(true);
      let token = null;
      token = 'customer-'+btoa(this.userNameOrEmail+':'+this.userPassword);
      //let partner = await this.checkIfPartnerExist(this.userNameOrEmail);

      const request1 = axios.get(appConstants.SERVICESURL+'/api/v1/resellers/search?keyword='+this.userNameOrEmail+'&status=all&per_page=10&page=1');
      const request2 = axios.get(appConstants.SITEURL+'/wp-json/custom-api/v1/orders/order_number/'+this.userPassword);

      Promise.all([request1, request2])
      .then(([response1, response2]) => {
        
        switch (true) {
          case (!response1.data.resellers.length && !!response2.data?.id):
            if (response2.data.billing.email == this.userNameOrEmail) {
              store.commit('SET_JWT_TOKEN', token);
              store.commit('SET_SESSION_TYPE', appConstants.LOGIN_TYPE.CUSTOMER);
              store.commit('SET_SESSION_EMAIL', this.userNameOrEmail);
              this.startInactivityTimer();
              this.$router.push({ name: 'OrdersList' });
            } else {
              Swal.fire({
                  icon: 'error',
                  title: "Error trying to login",
                  text: 'Email is not associated with this Order Number!',
                  showCancelButton: false,
                  confirmButtonText: "Close",
              });
            }
            this.toggleFullScreenSpinner(false);
            break;
          case (response1.data.resellers.length && !!response2.data?.id):
              store.commit('SET_SESSION_RAILS_ID', response1.data.resellers[0].id);
              store.commit('SET_SESSION_RAILS_DATA', response1.data.resellers[0]);
              store.commit('SET_CURRENT_SESSION_FIRSTNAME', response1.data.resellers[0].firstname);
              store.commit('SET_CURRENT_SESSION_LASTNAME', response1.data.resellers[0].lastname);
              store.commit('SET_SESSION_TYPE', appConstants.LOGIN_TYPE.PARTNER);
              store.commit('SET_SESSION_EMAIL', this.userNameOrEmail);
              store.commit('SET_JWT_TOKEN', token);
              this.toggleFullScreenSpinner(false);
              this.startInactivityTimer();
              this.$router.push({ name: 'OrdersList' });
            break;
          case (response1.data.resellers.length && !response2.data?.id):
            var partner = response1.data.resellers.filter((partner) => partner.reseller_code == this.userPassword);
            if (partner.length) {
              store.commit('SET_SESSION_RAILS_ID', partner[0].id);
              store.commit('SET_SESSION_RAILS_DATA', partner[0]);
              store.commit('SET_CURRENT_SESSION_FIRSTNAME', partner[0].firstname);
              store.commit('SET_CURRENT_SESSION_LASTNAME', partner[0].lastname);
              store.commit('SET_SESSION_TYPE', appConstants.LOGIN_TYPE.PARTNER);
              store.commit('SET_SESSION_EMAIL', this.userNameOrEmail);
              store.commit('SET_JWT_TOKEN', token);
              this.startInactivityTimer();
              this.$router.push({ name: 'OrdersList' });
            } else {
              Swal.fire({
                  icon: 'error',
                  title: "Error trying to login",
                  text: 'Customer / Partner does not exist',
                  showCancelButton: false,
                  confirmButtonText: "Close",
              });
            }
            this.toggleFullScreenSpinner(false);
            break;
          default:
            this.toggleFullScreenSpinner(false);
            Swal.fire({
                icon: 'error',
                title: "Error trying to login",
                text: 'Customer / Partner does not exist',
                showCancelButton: false,
                confirmButtonText: "Close",
            });
            break;
        }
        
      })
      .catch(error => {
        console.log(error);
      });

    },
    getQueryParams() {
      this.queryParams = this.route.query;
      this.showQueryParams = true;
    },
    resetRecoveryModalFields() {
      this.recoveryEmail = '';
    },
    resetRecoveryModalErrors() {
      this.recoveryResponseError = false;
      this.recoveryResponseErrorMessage = null;
      this.isRecoveryLoading = false;
      document.getElementById("recovery-email").classList.remove("border", "border-danger");
    },
    toggleRecoveryModal(bool) {
      const modalElement = document.getElementById('recoveryModal');
      
      if (!this.recoveryModalInstance) {
        this.recoveryModalInstance = new Modal(modalElement, {
          backdrop: 'static',
          keyboard: false
        });
      }
      
      if (bool) this.recoveryModalInstance.show();
      else this.recoveryModalInstance.hide();
    },
    showRecoveryModal() {
      this.resetRecoveryModalErrors();
      this.resetRecoveryModalFields();
      this.toggleRecoveryModal(true);
    },
    hideRecoveryModal() {
       this.isRecoveryLoading = false;
       this.toggleRecoveryModal(false);
     },
    submitRecovery: async function () {
      this.resetRecoveryModalErrors();
      let hasInvalidField = false;
      
      if (this.recoveryEmail.trim().length == 0 || !this.validateEmail(this.recoveryEmail)) {
        document.getElementById("recovery-email").classList.add("border", "border-danger");
        hasInvalidField = true;
      }
      if (hasInvalidField) return;
      
      this.isRecoveryLoading = true;      
      const request1 = axios.get(appConstants.SERVICESURL+'/api/v1/resellers/search?keyword='+this.recoveryEmail+'&status=all&per_page=10&page=1');
      const request2 = axios.get(appConstants.SITEURL+'/wp-json/custom-api/v1/orders/billing_email/?email='+this.recoveryEmail);

      Promise.all([request1, request2])
        .then(async ([response1, response2]) => {
          let isPartnerFound = response1.data.resellers && response1.data.resellers.length > 0,
             isPartnerApproved = isPartnerFound && response1.data.resellers[0].status == 'approved',
             isPartnerPending = isPartnerFound && response1.data.resellers[0].status == 'pending';

          // Process reseller data
          if (isPartnerFound && isPartnerApproved && response1.data.resellers[0]) {
            let templateID = '0p7kx4xqopeg9yjr';  //template ID for Approved Partner Application email
            let mailerSendResponse = await axios({
              method: 'post',
              url: appConstants.MAKROURL + '/mailersend/mailersend.php',
              headers: {
                  'Content-Type': 'application/json'
              },
              data: {
                  "recipients": [
                      { "email": this.recoveryEmail, "name": response1.data.resellers[0].firstname + ' ' + response1.data.resellers[0].lastname }          // PRD
                  ],
                  "personalization": [
                      {
                        name: response1.data.resellers[0].firstname,
                        discountCode: response1.data.resellers[0].reseller_code,
                        portalUrl: appConstants.SITEURL+'/portal/',
                        companyPhoneNumber: appConstants.COMPANY_PHONE_NUMBER,
                        companyAddress: appConstants.COMPANY_ADDRESS,
                        discountPercentage: appConstants.PARTNER_DISCOUNT_PERCENTAGE
                      }
                  ],
                  "subject": 'Partner Code Request',
                  "reply_to": appConstants.SUPPORT_EMAIL,
                  "reply_to_name": "Maks Enterprises LLC",
                  "template_id": templateID
              }
            });

            if (mailerSendResponse.data.success) {
              console.log("Recovery email sent!");
              this.hideRecoveryModal();
              Swal.fire({
                icon: 'success',
                title: "Email Sent!",
                text: 'Your partner discount code has been sent to your email.',
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            }
        }

        if (isPartnerFound && isPartnerPending && response1.data.resellers[0]) {
          console.log("Pending partner found:", response1.data.resellers[0]);
          this.hideRecoveryModal();
          Swal.fire({
            icon: 'info',
            title: "Application Pending",
            text: 'Your partner application is currently pending approval. Please contact our support team for assistance.',
            showCancelButton: false,
            confirmButtonText: "OK",
          });
         }

        if (response1.data.resellers.length == 0 && response2.data.orders && response2.data.orders.length > 0 && response2.data.orders[0]) {
          this.recoveryOrderNumber = response2.data.orders[0].order_number;
          let _message = `<p>You have requested for the recovery of your order number associated with your email.</p>` +
                          `<p>This is your order number:</p><p><strong>${response2.data.orders[0].order_number}</strong>.</p>` + 
                          `<p>Use your <strong>email</strong> and <strong>order number</strong> to access your order history.</p>` +
                          `<a href="${appConstants.SITEURL + '/portal'}">Proceed to Partner Portal.</a>`

          let templateID = 'neqvygm95p8l0p7w';  //template ID for generic email
          let mailerSendResponse = await axios({
            method: 'post',
            url: appConstants.MAKROURL + '/mailersend/mailersend.php',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                "recipients": [
                  { "email": this.recoveryEmail, "name": response2.data.orders[0].billing.first_name + ' ' + response2.data.orders[0].billing.last_name }          // PRD
                ],
                "personalization": [
                    {
                      "name": response2.data.orders[0].billing.first_name,
                      "message": _message,
                      "currentYear": new Date().getFullYear(),
                      "companyAddress": appConstants.COMPANY_ADDRESS,
                      "companyPhoneNumber": appConstants.COMPANY_PHONE_NUMBER,
                    }
                ],
                "subject": 'Order Number Request',
                "reply_to": appConstants.SUPPORT_EMAIL,
                "reply_to_name": "Maks Enterprises LLC",
                "template_id": templateID
            }
          });
          
           if (mailerSendResponse.data.success) {
             console.log("Recovery email sent!");
             this.hideRecoveryModal();
             Swal.fire({
               icon: 'success',
               title: "Email Sent!",
               text: 'Your order number has been sent to your email.',
               showCancelButton: false,
               confirmButtonText: "OK",
             });
           }
        } 

        // Handle case where no partner or order data is found
        if(response1.data.resellers && response1.data.resellers.length == 0 && 
          response2.data.orders && response2.data.orders.length == 0) {            
          this.recoveryResponseError = true;
          this.recoveryResponseErrorMessage = "Invalid email. No order history was found.";
          this.isRecoveryLoading = false;
        }
      })
      .catch(error => {
        console.log('Error in recovery requests:', error);
        // this.recoveryResponseError = true;
        // this.recoveryResponseErrorMessage = "An error occurred while processing your request.";
        this.isRecoveryLoading = false;

        Swal.fire({
          icon: 'error',
          title: "Error processing your request",
          text: 'An error occurred while processing your request.',
          showCancelButton: false,
          confirmButtonText: "Close",
      });
      });
    }
  },
  mounted() {
    setTimeout( () => {
      this.toggleFullScreenSpinner(false);
    }, 500);
    this.userNameOrEmail = this.currentSessionEmail;
    //this.checkIfTokenIsValid();

    //comment this on production
    if (JSON.parse(localStorage.getItem('vuex'))?.jwtToken) {
     this.$router.push({ name: 'Dashboard' }); // Redirect to login
    }
   },
   beforeUnmount() {
     if (this.recoveryModalInstance) {
       this.recoveryModalInstance.dispose();
       this.recoveryModalInstance = null;
     }
   }
 });
</script>
    